import { render, staticRenderFns } from "./WarehouseFilters.vue?vue&type=template&id=1b71cf58"
import script from "./WarehouseFilters.vue?vue&type=script&lang=js"
export * from "./WarehouseFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports